<template>
	<div class="friend-group-quick-select">
		<empty-state
			v-if="showGroups.length === 0"
			class="list-empty-state"
			icon="el-icon-folder-opened"
			:title="emptyTitle"
			compact
		></empty-state>
			<virtual-scroller
				v-else
				class="scroll-box"
				:items="showGroups"
				:item-height="46"
				:item-key-getter="getGroupRowKey"
				@reach-bottom="onReachBottom"
			>
			<template v-slot="{ item: group }">
				<div class="group-row">
					<div
						class="group-item"
						:class="{ checked: isGroupChecked(group) }"
						tabindex="0"
						@click="onToggleGroup(group)"
						@keydown.enter.prevent="onToggleGroup(group)"
						@keydown.space.prevent="onToggleGroup(group)"
					>
						<div class="group-main">
							<div class="group-name" :title="resolveGroupName(group)">{{ resolveGroupName(group) }}</div>
							<div class="group-count">{{ group.memberCount }} 人</div>
						</div>
					</div>
				</div>
			</template>
		</virtual-scroller>
	</div>
</template>

<script>
import VirtualScroller from '../common/VirtualScroller.vue';

export default {
	name: 'friendGroupQuickSelect',
	components: {
		VirtualScroller
	},
	props: {
		groups: {
			type: Array,
			default: () => []
		},
		emptyTitle: {
			type: String,
			default: '暂无好友分组'
		},
		checkedGroupIds: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		showGroups() {
			return Array.isArray(this.groups) ? this.groups : [];
		},
		checkedGroupIdSet() {
			return new Set((Array.isArray(this.checkedGroupIds) ? this.checkedGroupIds : [])
				.map((id) => String(id))
				.filter(Boolean));
		}
	},
		methods: {
			getGroupRowKey(group) {
				return group && group.id !== undefined && group.id !== null
					? `friend-group:${group.id}`
					: '';
			},
			resolveGroupName(group) {
				return group.name || '未命名分组';
			},
		isGroupChecked(group) {
			const id = group && group.id;
			return id !== undefined && id !== null && this.checkedGroupIdSet.has(String(id));
		},
		onToggleGroup(group, checked) {
			if (!group) {
				return;
			}
			const nextChecked = typeof checked === 'boolean' ? checked : !this.isGroupChecked(group);
			this.$emit('toggle-group', {
				group,
				checked: nextChecked
			});
			// 保持旧事件兼容（仅在选中时触发）
			if (nextChecked) {
				this.$emit('select-group', group);
			}
		},
		onReachBottom(event) {
			this.$emit('reach-bottom', event);
		}
	}
};
</script>

<style scoped lang="scss">
.friend-group-quick-select {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;

	.scroll-box {
		flex: 1;
		min-height: 0;
	}

	.list-empty-state {
		flex: 1;
		min-height: 180px;
	}

	.group-row {
		height: 46px;
		padding: 2px 6px;
		box-sizing: border-box;
	}

	.group-item {
		display: flex;
		align-items: center;
		gap: 12px;
		height: 42px;
		width: 100%;
		margin: 0;
		padding: 0 12px;
		box-sizing: border-box;
		border-radius: 10px;
		border: 1px solid var(--im-control-border);
		background: var(--im-control-soft-bg);
		cursor: pointer;
		transition: border-color 0.2s ease, background-color 0.2s ease, opacity 0.2s ease;

		&:hover,
		&:focus {
			outline: none;
			border-color: rgba(var(--im-primary-rgb), 0.16);
			background: rgba(var(--im-primary-rgb), 0.04);
		}

		&.checked {
			border-color: rgba(var(--im-primary-rgb), 0.3);
			background: rgba(var(--im-primary-rgb), 0.08);
		}

	}

	.group-main {
		flex: 1;
		min-width: 0;
		text-align: left;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
	}

	.group-name {
		flex: 1;
		min-width: 0;
		font-size: 14px;
		font-weight: 500;
		color: var(--im-text-color);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.group-count {
		flex-shrink: 0;
		font-size: 12px;
		color: var(--im-text-color-light);
		font-weight: 500;
	}

}
</style>
